import axios, { type AxiosInstance } from 'axios';
import { getConfig } from './config';
import { responseErrorHandler, responseHandler } from './interceptors';

let instance: AxiosInstance | null = null;

export function getApi(): AxiosInstance {
  if (!instance) {
    const cfg = getConfig();

    instance = axios.create({
      baseURL: cfg.baseUrl,
      headers: cfg.defaultHeaders,
      withCredentials: cfg.withCredentials ?? true,
    });

    instance.interceptors.response.use(responseHandler, responseErrorHandler);

    if (cfg.onRequest) {
      instance.interceptors.request.use(cfg.onRequest);
    }
  }
  return instance;
}
